import { useGetGroupsForOrganisationQuery } from '@/app/redux/endpoints/groups';
import { useCurrentOrganisationId } from '@/app/redux/hooks/organisation';
import { Group } from '@/common/types/group';
import { useMemo } from 'react';

export function useGroups() {
  const { currentOrganisationId } = useCurrentOrganisationId();

  const {
    data: groups = [],
    isLoading,
    isFetching,
    error,
  } = useGetGroupsForOrganisationQuery(currentOrganisationId!, {
    skip: !currentOrganisationId,
  });

  const groupsById = useMemo(() => {
    const byId = new Map<string, Group>();
    for (const g of groups) byId.set(g.id, g);
    return byId;
  }, [groups]);

  return { groups, groupsById, isLoading, isFetching, error };
}

export function useStudentGroups(studentId: string): Group[] {
  const { currentOrganisationId } = useCurrentOrganisationId();

  const { data: allGroups = [] } = useGetGroupsForOrganisationQuery(
    currentOrganisationId!,
    {
      skip: !currentOrganisationId,
      selectFromResult: ({ data }) => ({ data }),
    },
  );

  return useMemo(
    () => allGroups.filter((g) => g.studentIds.includes(studentId)),
    [allGroups, studentId],
  );
}
